export default __webpack_public_path__ + "static/media/icon-opportunities-blue.2256a514.svg";